import React from 'react';
import { Dots3, Expand, MockGraph } from '../../../assets/icons';
import EfficiencyCurve from '../../calculation-section/pump/pump-plot/efficiency-curves/EfficiencyCurve';

interface CaseGraphProps {
    heading: string;
    chart1Data?: any;
}

const CaseGraph: React.FC<CaseGraphProps> = ({ heading, chart1Data}) => {
    return (
        <div className='flex flex-col items-center justify-center w-full gap-[30px] p-[18px] border-[1px] rounded-[8px] bg-transparent border-darkcolor-400'>
            <div className='flex justify-between pb-[12px] border-b-[1px] border-darkcolor-400 w-full'>
                <div className='text-neutral-25'>{heading}</div>
                <div className='flex'>
                    {/* <Expand />
                    <Dots3 /> */}
                </div>
            </div>
            <div className='w-full'>
                {/* <MockGraph /> */}
                <EfficiencyCurve  chart1Data={chart1Data} />
            </div>
        </div>
    )
};

export default CaseGraph;